import type { EchoOptions } from 'laravel-echo';
import Pusher from 'pusher-js';

export type ToolbarEchoParams = {
    appUrl: string;
    pusherKey: string;
    pusherHost: string;
    bearerToken: string;
    /** Pusher cluster; toolbar used `mt1` */
    cluster?: string;
};

/**
 * Options for `@laravel/echo-react` {@link import('@laravel/echo-react').configureEcho}.
 *
 * Aligns with the legacy Plus toolbar client (`toolbar/js/websocket/index.js`). Typical Vite env keys:
 *
 */
export function getToolbarEchoConfig(params: ToolbarEchoParams): EchoOptions<'pusher'> & { broadcaster: 'pusher' } {
    const base = params.appUrl.replace(/\/$/, '');
    const wsPort = 80;
    const wssPort = 443;

    return {
        broadcaster: 'pusher',
        Pusher,
        key: params.pusherKey,
        wsHost: params.pusherHost,
        wsPort,
        wssPort,
        forceTLS: true,
        encrypted: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
        cluster: params.cluster ?? 'mt1',
        bearerToken: params.bearerToken,
        authEndpoint: `${base}/broadcasting/auth`,
        namespace: false,
    };
}
